import { useSafeAreaInsets } from 'react-native-safe-area-context'
import type { MapDef } from '@warcarp/api-types'
import { useGameMapChromeHeight } from './useGameMapChrome'
import { mapChromeOffset, mapGameLayout } from '../lib/mapGameLayout'
import { portraitMapReserves } from '../lib/portraitMapLayout'
import { useStableWindowDimensions } from './useStableWindowDimensions'

/**
 * Portrait game-map reserves shared by the live map (GameMapHost) and the
 * snapshot (HistoricalActiveView), so entering a snapshot never resizes or
 * moves the board. Both maps use the retained measured header height, with a shared per-map
 * overlap. The snapshot banner replaces that exact row. Host measurements only
 * refine keyboard fitting; they never change the canvas sizing between views.
 */
export function usePortraitMapReserves(map: Pick<MapDef, 'id' | 'gameLayout'>) {
  const { height: windowHeight } = useStableWindowDimensions()
  const insets = useSafeAreaInsets()
  const topBarHeight = useGameMapChromeHeight()
  const topOverlap = mapChromeOffset(topBarHeight, mapGameLayout(map).topBarOverlap)
  const mapTop = insets.top + topBarHeight - topOverlap
  return { ...portraitMapReserves({ windowHeight, mapTop, topOverlap }), mapTop, windowHeight, topOverlap, topBarHeight }
}
